import React from "react"

const Chip = ({ text }) => {
    return (
        <div className="chip">
            <div className="chip__content">{text}</div>
        </div>
    )
}
export default Chip